import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { animationValues, transitionValues } from "../../utils/pageTransitions";
import Suppliers from "./callRequest/suppliers";
import Customers from "./callRequest/customers";
import {
  pause_customer_call_request,
  pause_suppliers_call_request,
  resume_suppliers_call_request,
  resume_customer_call_request,
  get_call_requests,
} from "../../redux/actions/adminActions";
import Spinner from "../reusables/spinner";

function CallRequest({
  supplierCallRequest,
  customerCallRequest,
  pauseSupplierCallRequest,
  resumeSupplierCallRequest,
  accessToken,
  pauseCustomerCallRequest,
  resumeCustomerCallRequest,
  getCallRequests,
}) {
  const [isLoading, setLoading] = useState(false);
  const [isLoading2, setLoading2] = useState(false);
  const handleSupplierRequest = () => {
    setLoading(true);
    if (supplierCallRequest === true) {
      pauseSupplierCallRequest(accessToken, () => setLoading(false));
    } else {
      resumeSupplierCallRequest(accessToken, () => setLoading(false));
    }
  };

  const handleCustomerRequest = () => {
    setLoading2(true);
    if (customerCallRequest === true) {
      pauseCustomerCallRequest(accessToken, () => setLoading2(false));
    } else {
      resumeCustomerCallRequest(accessToken, () => setLoading2(false));
    }
  };

  const getRequests = (type) => {
    // getCallRequests(type, 'pending' , accessToken);
  };

  useEffect(() => {
    // getRequests('supplier');
  }, []);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid suppliers">
        <div className="spaceBetween mobileBlock">
          <h2 className="sectionText--big textIsBold">
            Call Request Management
          </h2>

          <div className="textIsBold pt-2 mobileAlign d-flex">
            <button
              className={`${
                supplierCallRequest ? "btn__filled" : "btn__dark"
              } hasRadius d-flex`}
              onClick={handleSupplierRequest}
            >
              {supplierCallRequest ? "Pause" : "Resume"} Supplier Call Request
              {isLoading && <Spinner />}
            </button>
            <button
              className={`${
                customerCallRequest ? "btn__filled" : "btn__dark"
              } hasRadius mx-2 d-flex`}
              onClick={handleCustomerRequest}
            >
              {customerCallRequest ? "Pause" : "Resume"} Customer Call Request{" "}
              {isLoading2 && <Spinner />}
            </button>
          </div>
        </div>

        <Tabs className="pt-3">
          <TabList className="alignOnly sectionText--mid p-0">
            <Tab className="tabHead" onClick={() => getRequests("supplier")}>
              Suppliers
            </Tab>
            <Tab className="tabHead" onClick={() => getRequests("user")}>
              Customers
            </Tab>
          </TabList>

          <TabPanel>
            <Suppliers />
          </TabPanel>
          <TabPanel>
            <Customers />
          </TabPanel>
        </Tabs>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  supplierCallRequest: state.admin.supplierCallRequest,
  customerCallRequest: state.admin.customerCallRequest,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  pauseSupplierCallRequest: (token, success) =>
    dispatch(pause_suppliers_call_request(token, success)),
  resumeSupplierCallRequest: (token, success) =>
    dispatch(resume_suppliers_call_request(token, success)),
  pauseCustomerCallRequest: (token, success) =>
    dispatch(pause_customer_call_request(token, success)),
  resumeCustomerCallRequest: (token, success) =>
    dispatch(resume_customer_call_request(token, success)),
  // getCallRequests: (type, status, token) => dispatch(get_call_requests(type, status, token))
});

export default connect(mapStateToProps, mapDispatchToProps)(CallRequest);
